import { FormValueScope } from '@epages/react-components'
import type { ReactElement } from 'react'
import cc from 'classcat'

import CheckboxField from '../formComponents/CheckboxField'

type Props = {
  logo: ImmutableMap
  index: number
} & TranslateProps

export default function Logo({ t, logo, index }: Readonly<Props>): ReactElement {
  return (
    <FormValueScope key={index} name={index}>
      <div className={cc(['ep-footer-sections-settings-popover-item', { disabled: !logo.get('active') }])}>
        <label>
          <CheckboxField name="active" />
          {logo.get('title') || t(`paymentNames.${logo.get('id')}`)}
        </label>
      </div>
    </FormValueScope>
  )
}
